export default {"src":"/_next/static/media/analysis​.f9313d38.svg","height":61,"width":60};